"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_jss_1 = require("react-jss");
const useStyles = (0, react_jss_1.createUseStyles)({
    root: {
        background: "#1D7775",
        borderRadius: 5,
        color: "#eee",
        outline: "none",
        border: "none",
        fontFamily: '"Bubblegum Sans", cursive',
        textDecoration: "none",
        fontSize: 25,
        padding: "8px 16px",
        display: "block",
        textAlign: "center",
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
        zIndex: 1,
        transition: "transform 0.25s ease-out",
        "&:hover": {
            transform: "scale(1.05)",
        },
        "&:focus": {
            textDecoration: "underline",
        },
    },
    triangle: {
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        position: "absolute",
        zIndex: -1,
        background: "#155755",
        clipPath: "polygon(100% 0, 0 100%, 100% 100%)",
    },
});
const Button = (_a) => {
    var { Component = "button", children, className, onMouseEnter, onMouseLeave } = _a, rest = __rest(_a, ["Component", "children", "className", "onMouseEnter", "onMouseLeave"]);
    const classes = useStyles();
    return (react_1.default.createElement(Component, Object.assign({ className: `${classes.root} ${className}` }, rest, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onMouseEnter, onBlur: onMouseLeave }),
        react_1.default.createElement("div", { className: classes.triangle }),
        children));
};
exports.default = Button;
